import { Ic } from "../../components/Icons.jsx";
import { usePreferences } from "../preferences/usePreferences";
import { useI18n } from "../i18n/I18nProvider";

export function ThemeToggle() {
  const { theme, save } = usePreferences();
  const { t } = useI18n();
  return <div className="theme-toggle" role="group" aria-label={t("外观", "Appearance")}>
    <button type="button" aria-label={t("日间模式", "Light mode")} title={t("日间模式", "Light mode")} aria-pressed={theme === "light"}
      onClick={() => void save({ preferences: { theme: "light" } }).catch(() => {})}><Ic.Sun size={19} /></button>
    <button type="button" aria-label={t("夜间模式", "Dark mode")} title={t("夜间模式", "Dark mode")} aria-pressed={theme === "dark"}
      onClick={() => void save({ preferences: { theme: "dark" } }).catch(() => {})}><Ic.Moon size={19} /></button>
  </div>;
}
